import { apiFetch } from './api';

export async function listStaff({ page = 1, limit = 20, search = '' } = {}) {
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('limit', String(limit));
  if (search) params.set('search', search);
  const q = `?${params.toString()}`;
  return apiFetch(`/api/admin/users${q}`);
}

export async function createStaff({ email, password, fullName, phone, roleIds }) {
  return apiFetch('/api/admin/users', { method: 'POST', body: { email, password, fullName, phone, roleIds } });
}

export async function getStaff(id) {
  return apiFetch(`/api/admin/users/${id}`);
}

export async function updateStaff(id, payload) {
  return apiFetch(`/api/admin/users/${id}`, { method: 'PATCH', body: payload });
}

export async function deleteStaff(id) {
  return apiFetch(`/api/admin/users/${id}`, { method: 'DELETE' });
}

export async function resendVerificationEmail(id) {
  return apiFetch(`/api/admin/users/${id}/resend-verification-email`, { method: 'POST' });
}


